import { useAuthUser } from "react-auth-kit";
import { useState, useEffect } from "react";
import { AUTHKIT_STATE_KEY } from "config/authStorage";

/** Same as react-auth-kit `AuthStateUserObject` — app stores `{ user, token }` from login here. */
type AuthUserState = Record<string, any> | null;

export const useGetUserInfo = () => {
  const auth = useAuthUser();
  const [userDetails, setUserDetails] = useState<AuthUserState>(() => auth());

  useEffect(() => {
    const handleUserUpdate = (event: Event) => {
      const ce = event as CustomEvent<{ userState?: AuthUserState }>;
      if (ce.detail?.userState) {
        setUserDetails(ce.detail.userState);
        return;
      }
      const raw = localStorage.getItem(AUTHKIT_STATE_KEY);
      if (raw) {
        try {
          setUserDetails(JSON.parse(raw));
          return;
        } catch {
          /* ignore corrupt storage */
        }
      }
      setUserDetails(auth());
    };

    window.addEventListener("userInfoUpdated", handleUserUpdate);

    return () => {
      window.removeEventListener("userInfoUpdated", handleUserUpdate);
    };
  }, [auth]);

  const userInfo = userDetails?.user;
  const token = userDetails?.token ?? "";

  return { userInfo, token };
};
